/**
 * Bank Name Mapping Utility
 * Maps bank codes and abbreviations to readable Thai bank names
 */

export const BANK_NAMES: Record<string, string> = {
  // Bank codes (3-digit codes)
  '002': 'ธนาคารกรุงเทพ',
  '004': 'ธนาคารกสิกรไทย',
  '006': 'ธนาคารกรุงไทย',
  '011': 'ธนาคารทหารไทยธนชาต',
  '014': 'ธนาคารไทยพาณิชย์',
  '017': 'ธนาคารซีไอเอ็มบีไทย',
  '022': 'ธนาคารซิตี้แบงก์',
  '024': 'ธนาคารยูโอบี',
  '025': 'ธนาคารกรุงศรีอยุธยา',
  '030': 'ธนาคารออมสิน',
  '033': 'ธนาคารอาคารสงเคราะห์',
  '034': 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
  '065': 'ธนาคารธนชาต',
  '069': 'ธนาคารเกียรตินาคินภัทร',
  '070': 'ธนาคารไอซีบีซี',
  '071': 'ธนาคารไทยเครดิต',
  '073': 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
  '098': 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย',

  // Bank abbreviations/short codes
  'BBL': 'ธนาคารกรุงเทพ',
  'KBANK': 'ธนาคารกสิกรไทย',
  'KTB': 'ธนาคารกรุงไทย',
  'TMB': 'ธนาคารทหารไทยธนชาต',
  'TMBTHANA': 'ธนาคารทหารไทยธนชาต',
  'SCB': 'ธนาคารไทยพาณิชย์',
  'CIMB': 'ธนาคารซีไอเอ็มบีไทย',
  'CITI': 'ธนาคารซิตี้แบงก์',
  'UOB': 'ธนาคารยูโอบี',
  'BAY': 'ธนาคารกรุงศรีอยุธยา',
  'KRUNGSRI': 'ธนาคารกรุงศรีอยุธยา',
  'GSB': 'ธนาคารออมสิน',
  'GHB': 'ธนาคารอาคารสงเคราะห์',
  'BAAC': 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
  'THANACHART': 'ธนาคารธนชาต',
  'TISCO': 'ธนาคารทิสโก้',
  'KK': 'ธนาคารเกียรตินาคินภัทร',
  'KIATNAKIN': 'ธนาคารเกียรตินาคินภัทร',
  'ICBC': 'ธนาคารไอซีบีซี',
  'TCRB': 'ธนาคารไทยเครดิต',
  'LH': 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
  'SME': 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อม',
}

/**
 * Get readable Thai bank name from code or abbreviation
 * @param bankCode - Bank code (e.g., "014", "SCB", "KRUNGSRI")
 * @returns Thai bank name or original code if not found
 */
export function getBankName(bankCode: string | null | undefined): string {
  if (!bankCode) return '-'
  
  const normalized = bankCode.trim().toUpperCase()
  return BANK_NAMES[normalized] || bankCode
}

/**
 * Get short bank display name (for compact displays)
 * Returns the bank name with "ธนาคาร" prefix removed
 */
export function getBankShortName(bankCode: string | null | undefined): string {
  const fullName = getBankName(bankCode)
  if (fullName === '-' || !fullName.startsWith('ธนาคาร')) return fullName
  return fullName.replace('ธนาคาร', '').trim()
}
